module.exports = __webpack_public_path__ + "static/media/paused.6572d272.svg";